<mat-accordion class="mat-pb">
    <form [formGroup]="educationForm" style="padding: 1px;">
        <mat-expansion-panel hideToggle #panel (closed)="panelClosure($event,panel)">
            <mat-expansion-panel-header>
                <mat-panel-title class="heading-md">
                    {{label |translate}}
                    <mat-radio-group formControlName="educationLevel">
                        <mat-radio-button [value]="item.id" *ngFor="let item of masters.educationLevelList"
                            (click)="panelEvent($event,panel)">
                            {{item.title}} </mat-radio-button>
                    </mat-radio-group>
                </mat-panel-title>
                <mat-panel-description class="panel-description">

                </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row form-group">

                <div class="col-md-2">
                    <tm-select [form_group]="educationForm" [form_control]="'educationType'" [appearance]="'outline'"
                        [options]="masters.educationTypeList" [label]="'Education Type'" [mandatory]="1"
                        [hide_label]="1" [data]="educationForm.value.educationType"
                        [placeholder]="'Select education type'">
                    </tm-select>
                </div>
                <div class="col-md-3">
                    <tm-select [appearance]="'outline'" [options]="masters.educationList||[]" [hide_label]="1"
                        [form_group]="educationForm" form_control="educationCode" title_property="title"
                        id_property="educationCode" float_label="always" [label]="'RESUME.education' | translate"
                        [data]="educationForm.value.educationCode" [placeholder]="'  Select education '"
                        (selected_obj)="changeEducation($event)">
                    </tm-select>
                </div>
                <div class="col-md-4">
                    <tm-select [options]="masters.specializationList||[]" [form_group]="educationForm" [hide_label]="1"
                        [appearance]="'outline'" (selected_obj)="specialicationChanged($event)"
                        form_control="specializationCode" title_property="title" id_property="specializationCode"
                        float_label="always" [label]="'RESUME.specialization' | translate"
                        [data]="educationForm.value.specializationCode" [disabled]="current_education.noSpecialization"
                        [mandatory]="current_education.isSpecialization " [placeholder]="'Select specialization'">
                    </tm-select>
                </div>
                <div class="col-md-3">
                    <div class="prefix-control" style="width: 60%;">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label style="text-align: right;">
                                <!-- {{ 'Score' | translate }} -->
                            </mat-label>
                            <input min="1" max="100" type="number" class="w-93" matInput
                                [required]="current_education && current_education.isPercentage? true:false"
                                placeholder="{{ 'Score' | translate }}" formControlName="percentage" [min]="1"
                                [max]="100">
                            <mat-error *ngIf="educationForm.get('percentage').hasError('pattern')">
                                {{'ERROR.max_value'|translate}} 100
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="main-control" style="width: 40%;">
                        <tm-select [form_group]="educationForm" [form_control]="'percentageType'" [hide_label]="1"
                            [appearance]="'outline'" [options]="masters.educationScoreTypeList"
                            [label]="'Education level'" [mandatory]="1" [data]="educationForm.value.percentageType"
                            [placeholder]="'Select education level'">
                        </tm-select>
                    </div>

                </div>
                <div class="col-md-2">
                    <tm-month-year [form]="educationForm" [controlName]="'passingMN'" [appearance]="'outline'"
                        [float_label]="'always'" [value]="educationForm.value.passingMN" [placeholder]="'Passing year'">
                    </tm-month-year>
                </div>

                <div class="col-md-4">
                    <tm-select [options]="masters.universityList||[]" [form_group]="educationForm" [auto_addition]="1"
                        [hide_label]="1" [auto_data]="educationForm.value.university" [auto_form_control]="'university'"
                        [appearance]="'outline'" form_control="universityCode" title_property="title"
                        id_property="universityCode" float_label="always" [label]="'University/School' | translate"
                        [data]="educationForm.value.universityCode" [placeholder]="'University' | translate">
                    </tm-select>
                </div>
                <div class="col-md-4">
                    <tm-select [options]="masters.collegeList||[]" [form_group]="educationForm" [auto_addition]="1"
                        [hide_label]="1" [auto_data]="educationForm.value.collegeName"
                        [auto_form_control]="'collegeName'" [appearance]="'outline'" form_control="collegeId"
                        title_property="title" id_property="id" float_label="always"
                        [label]="'University/School' | translate" [data]="educationForm.value.collegeId"
                        [placeholder]="'Name of School/College' | translate">
                    </tm-select>
                    <mat-form-field appearance="outline" floatLabel="always" *ngIf="false">
                        <mat-label>
                            <!-- {{ 'Score' | translate }} -->
                        </mat-label>
                        <input min="1" max="100" class="w-93" matInput
                            placeholder="{{ 'Name of School/College' | translate }}" formControlName="collegeName">
                        <!-- <mat-error *ngIf="educationForm.get('collegeName').hasError('pattern')">
                            {{'ERROR.max_value'|translate}} 100
                        </mat-error> -->
                    </mat-form-field>
                </div>

                <div class="col-md-2 text-right" *ngIf="educationForm.value.educationLevel==6">
                    <button class="btn btn-sm js-btn-save mat-mt" (click)="saveChanges(panel)"> Ok </button>
                </div>
            </div>
            <form [formGroup]="educationForm2" [ngClass]="{'d-none':educationForm.value.educationLevel==6}">
                <div class="row form-group">
                    <div class="col-md-12">
                        <h6>
                            Post Graduate
                        </h6>
                    </div>
                    <div class="col-md-4" *ngIf="false">
                        <tm-select [form_group]="educationForm2" [form_control]="'educationLevel'"
                            [appearance]="'outline'" [hide_label]="1" [options]="educationLevelList"
                            [label]="'Education level'" [data]="educationForm2.value.educationLevel"
                            [placeholder]="'Select education level'">
                        </tm-select>
                    </div>
                    <div class="col-md-3">
                        <tm-select [appearance]="'outline'" [options]="masters.educationList||[]" [hide_label]="1"
                            [form_group]="educationForm2" form_control="educationCode" title_property="title"
                            id_property="educationCode" float_label="always" [label]="'RESUME.education' | translate"
                            [data]="educationForm2.value.educationCode" [placeholder]="'  Select education '"
                            (selected_obj)="changeEducation($event,2)">
                        </tm-select>
                    </div>
                    <div class="col-md-4">
                        <tm-select [options]="masters.specializationList||[]" [form_group]="educationForm2"
                            [hide_label]="1" [appearance]="'outline'" (selected_obj)="specialicationChanged($event,2)"
                            form_control="specializationCode" title_property="title" id_property="specializationCode"
                            float_label="always" [label]="'RESUME.specialization' | translate"
                            [data]="educationForm2.value.specializationCode"
                            [disabled]="current_education.noSpecialization"
                            [mandatory]="current_education.isSpecialization " [placeholder]="'Select specialization'">
                        </tm-select>
                    </div>
                    <div class="col-md-3">
                        <div class="prefix-control" style="width: 60%;">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label style="text-align: right;">
                                    <!-- {{ 'Score' | translate }} -->
                                </mat-label>
                                <input min="1" max="100" type="number" class="w-93" matInput
                                    [required]="current_education && current_education.isPercentage? true:false"
                                    placeholder="{{ 'Score' | translate }}" formControlName="percentage" [min]="1"
                                    [max]="100">
                                <mat-error *ngIf="educationForm2.get('percentage').hasError('pattern')">
                                    {{'ERROR.max_value'|translate}} 100
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="main-control" style="width: 40%;">
                            <tm-select [form_group]="educationForm2" [form_control]="'percentageType'" [hide_label]="1"
                                [appearance]="'outline'" [options]="masters.educationScoreTypeList"
                                [label]="'Education level'" [mandatory]="1" [data]="educationForm2.value.percentageType"
                                [placeholder]="'Select education level'">
                            </tm-select>
                        </div>

                    </div>
                    <div class="col-md-2">
                        <tm-month-year [form]="educationForm2" [controlName]="'passingMN'" [appearance]="'outline'"
                            [float_label]="'always'" [value]="educationForm2.value.passingMN"
                            [placeholder]="'Passing year'">
                        </tm-month-year>
                    </div>

                    <div class="col-md-4">
                        <tm-select [options]="masters.universityList||[]" [form_group]="educationForm2"
                            [auto_addition]="1" [hide_label]="1" [auto_data]="educationForm2.value.university"
                            [auto_form_control]="'university'" [appearance]="'outline'" form_control="universityCode"
                            title_property="title" id_property="universityCode" float_label="always"
                            [label]="'University/School' | translate" [data]="educationForm2.value.universityCode"
                            [placeholder]="'University' | translate">
                        </tm-select>
                    </div>
                    <div class="col-md-4">
                        <tm-select [options]="masters.collegeList||[]" [form_group]="educationForm2" [auto_addition]="1"
                            [hide_label]="1" [auto_data]="educationForm2.value.collegeName"
                            [auto_form_control]="'collegeName'" [appearance]="'outline'" form_control="collegeId"
                            title_property="title" id_property="id" float_label="always"
                            [label]="'University/School' | translate" [data]="educationForm2.value.collegeId"
                            [placeholder]="'Name of School/College' | translate">
                        </tm-select>
                    </div>
                    <div class="col-md-2">
                        <tm-select [form_group]="educationForm2" [form_control]="'educationType'"
                            [appearance]="'outline'" [options]="masters.educationTypeList" [label]="'Education Type'"
                            [mandatory]="1" [hide_label]="1" [data]="educationForm2.value.educationType"
                            [placeholder]="'Select education type'">
                        </tm-select>
                    </div>
                    <div class="col-md-2 text-right" *ngIf="educationForm.value.educationLevel==7">
                        <button class="btn btn-sm js-btn-save mat-mt" (click)="saveChanges(panel)"> Ok
                        </button>
                    </div>
                </div>
            </form>
            <form [formGroup]="educationForm3"
                [ngClass]="{'d-none':educationForm.value.educationLevel==6 ||educationForm.value.educationLevel==7 }">
                <div class="row ">
                    <div class="col-md-12">
                        <h6>
                            Phd
                        </h6>
                    </div>
                    <div class="col-md-4" *ngIf="false">
                        <tm-select [form_group]="educationForm3" [form_control]="'educationLevel'"
                            [appearance]="'outline'" [hide_label]="1" [options]="educationLevelList"
                            [label]="'Education level'" [data]="educationForm3.value.educationLevel"
                            [placeholder]="'Select education level'">
                        </tm-select>
                    </div>
                    <div class="col-md-3">
                        <tm-select [appearance]="'outline'" [options]="masters.educationList||[]" [hide_label]="1"
                            [form_group]="educationForm3" form_control="educationCode" title_property="title"
                            id_property="educationCode" float_label="always" [label]="'RESUME.education' | translate"
                            [data]="educationForm3.value.educationCode" [placeholder]="'  Select education '"
                            (selected_obj)="changeEducation($event,3)">
                        </tm-select>
                    </div>
                    <div class="col-md-4">
                        <tm-select [options]="masters.specializationList||[]" [form_group]="educationForm3"
                            [hide_label]="1" [appearance]="'outline'" (selected_obj)="specialicationChanged($event,3)"
                            form_control="specializationCode" title_property="title" id_property="specializationCode"
                            float_label="always" [label]="'RESUME.specialization' | translate"
                            [data]="educationForm3.value.specializationCode"
                            [disabled]="current_education.noSpecialization"
                            [mandatory]="current_education.isSpecialization " [placeholder]="'Select specialization'">
                        </tm-select>
                    </div>
                    <div class="col-md-3">
                        <div class="prefix-control" style="width: 60%;">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label style="text-align: right;">
                                    <!-- {{ 'Score' | translate }} -->
                                </mat-label>
                                <input min="1" max="100" type="number" class="w-93" matInput
                                    [required]="current_education && current_education.isPercentage? true:false"
                                    placeholder="{{ 'Score' | translate }}" formControlName="percentage" [min]="1"
                                    [max]="100">
                                <mat-error *ngIf="educationForm3.get('percentage').hasError('pattern')">
                                    {{'ERROR.max_value'|translate}} 100
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="main-control" style="width: 40%;">
                            <tm-select [form_group]="educationForm3" [form_control]="'percentageType'" [hide_label]="1"
                                [appearance]="'outline'" [options]="masters.educationScoreTypeList"
                                [label]="'Education level'" [mandatory]="1" [data]="educationForm3.value.percentageType"
                                [placeholder]="'Select education level'">
                            </tm-select>
                        </div>

                    </div>
                    <div class="col-md-2">
                        <tm-month-year [form]="educationForm3" [controlName]="'passingMN'" [appearance]="'outline'"
                            [float_label]="'always'" [value]="educationForm3.value.passingMN"
                            [placeholder]="'Passing year'">
                        </tm-month-year>
                    </div>

                    <div class="col-md-4">
                        <tm-select [options]="masters.universityList||[]" [form_group]="educationForm3"
                            [auto_addition]="1" [hide_label]="1" [auto_data]="educationForm3.value.university"
                            [auto_form_control]="'university'" [appearance]="'outline'" form_control="universityCode"
                            title_property="title" id_property="universityCode" float_label="always"
                            [label]="'University/School' | translate" [data]="educationForm3.value.universityCode"
                            [placeholder]="'University' | translate">
                        </tm-select>
                    </div>
                    <div class="col-md-4">
                        <tm-select [options]="masters.collegeList||[]" [form_group]="educationForm3" [auto_addition]="1"
                            [hide_label]="1" [auto_data]="educationForm3.value.collegeName"
                            [auto_form_control]="'collegeName'" [appearance]="'outline'" form_control="collegeId"
                            title_property="title" id_property="id" float_label="always"
                            [label]="'University/School' | translate" [data]="educationForm3.value.collegeId"
                            [placeholder]="'Name of School/College' | translate">
                        </tm-select>
                    </div>
                    <div class="col-md-2">
                        <tm-select [form_group]="educationForm3" [form_control]="'educationType'"
                            [appearance]="'outline'" [options]="masters.educationTypeList" [label]="'Education Type'"
                            [mandatory]="1" [hide_label]="1" [data]="educationForm3.value.educationType"
                            [placeholder]="'Select education type'">
                        </tm-select>
                    </div>
                    <div class="col-md-2 text-right" *ngIf="educationForm.value.educationLevel==8">
                        <button class="btn btn-sm js-btn-save  mat-mt" (click)="saveChanges(panel)"> Ok
                        </button>
                    </div>

                </div>
            </form>
        </mat-expansion-panel>
    </form>


</mat-accordion>